// Import modules...
import Vue from "vue"
import { createInertiaApp, Head, Link } from "@inertiajs/inertia-vue"
import { InertiaProgress } from "@inertiajs/progress"
import PortalVue from "portal-vue"
import Mixins from "./mixins"
import Vue2TouchEvents from "vue2-touch-events"
import VueCurrencyFilter from "vue-currency-filter"
import { StripePlugin } from "@vue-stripe/vue-stripe"
import VuePluralize from "vue-pluralize"
import Avatar from "@/Jetstream/Avatar"

require("./bootstrap")

Vue.component("avatar", Avatar)
Vue.component("Head", Head)
Vue.component("Link", Link)
Vue.component("inertia-link", Link) // used for inertia-tables

// noinspection JSUnresolvedVariable
Vue.mixin({ methods: { route } })
Vue.mixin(Mixins)

Vue.use(VuePluralize)
Vue.use(PortalVue)
Vue.use(Vue2TouchEvents)
Vue.use(VueCurrencyFilter, {
    symbol: "$",
    thousandsSeparator: ",",
    fractionCount: 0,
    fractionSeparator: ".",
    symbolPosition: "front",
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
})
Vue.use(StripePlugin, {
    pk: process.env.NODE_ENV === "production" ? process.env.MIX_STRIPE_KEY : process.env.MIX_STRIPE_KEY_DEV,
    stripeAccount: process.env.MIX_APP_NAME,
    apiVersion: "2020-08-27",
    locale: "en",
})

//NProgess loading bar
InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,

    // The color of the progress bar.
    color: "#29d",

    // Whether to include the default NProgress styles.
    includeCSS: true,

    // Whether the NProgress spinner will be shown.
    showSpinner: false,
})

// Inertia Events (protonemedia/inertiajs-events-laravel-dusk)
window.inertiaEventsCount = {
    navigateCount: 0,
    successCount: 0,
    errorCount: 0,
}

createInertiaApp({
    title: (title) => (title === " " ? "Throbo | Online Challenges & Earn" : `${title} | Online Challenges & Earn`),
    // title: (title) => `${title} | Throbo | Online Challenges & Earn`,
    resolve: (name) => require(`./Pages/${name}`).default,
    setup({ el, App, props }) {
        new Vue({
            render: (h) => h(App, props),
        }).$mount(el)
    },
})
